import React, { Fragment } from 'react';
import { EditableSkillsContentType } from '../../../Context/Skill/SkillState';
import SkillContentEditor from '../../Layout/SkillContentEditor/SkillContentEditor';

const SkillQuickSheetPage = () => {

    const contentName = 'Quick sheet';
    const placeholderText = 'Add quick sheet here';
    const contentType = EditableSkillsContentType.QuickSheet;
    
    return (
        <Fragment>
            <SkillContentEditor contentName={contentName} placeholderText={placeholderText} contentType={contentType}></SkillContentEditor>
        </Fragment>
    );
};

export default SkillQuickSheetPage;